import React from "react";
import ParticlesBackground from "../shared/ParticlesBackground";
import HomePage from "./HomePage";
import AboutSection from "../sections/AboutSection";
import CoreValues from "../sections/CoreValues";
import OurObjectives from "../sections/ObjectivesSection";
import Footer from "../components/Footer";
import ProgramSection from "../sections/ProgramSection";
import TestimonialsSection from "../sections/EventsSection";
import EventsPage from "../sections/GallerySection";

export default function Landing() {
  return (
    <div className="relative w-full">

      <div id="home">
      <ParticlesBackground />
      </div>

      <div id="about">
        <AboutSection />
        <CoreValues />
      </div>

      

      <div id="objectives">
        <OurObjectives />
      </div>

      <div id="programmes">
        <ProgramSection />
      </div>

       <div id="events">
        <EventsPage />
        <TestimonialsSection />

       </div>

    

      <div id="footer">
        <Footer />
      </div>
    </div>
  );
}
